module.exports = __webpack_public_path__ + "static/img/4.0b60ea8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xiaoshuo/4.png
// module id = aj5Y
// module chunks = 1